/**
 * Mobile - Header organism
 */

// Imports
import {
  resetContainer,
  panelRenderEvent
} from '../../common/widgets/Tree';
import {
  siteId,
  headerId,
  overlayClass,
  stickyClass,
  init as initialInit,
  getHeader,
  setInitialHeight,
  addOverlay as initialAddOverlay,
} from '../../common/organism/header';

import {
  registerWindowResizeCallback,
} from '../../common/tools/WindowResizeHandler';
import * as events from '../../common/Events';

import * as search from '../molecule/search';
import cartItemsInit from '../molecule/cart-items';
import * as Page from '../../common/template/page';
import * as cart from '../Cart';
import {
  isAlgoliaOn,
  isTargetChildOf
} from '../../common/Utils';

require('jqueryUi');

// Constants (ids)
const sideNavId = 'sideNavSection';
const searchAreaId = 'searchArea';

const openMenuButtonId = 'openMenuButton';
const closeMenuButtonId = 'closeMenuButton';
const searchButtonId = 'searchButton';
const searchInputId = 'searchField';
const popinOverlayId = '#popinOverlay';

// Constants (classes)
const sideNavClass = 'o-side-navigation';
const displaySideNavClass = `${sideNavClass}--slided`;
const noDisplayClass = 'u-no-display';
const navMainClass = 'm-nav--main';
const navItemClass = 'm-nav__item';
const siteClass = 't-page__site';
const siteNoTransitionClass = `${siteClass}--no-transition`;
const popinOverlayHideClass = 'o-popin-overlay--hide';

// Constants (attributes)
const dataSearchAreaAttr = 'data-search-area';

// Constants (functional)
const openingThreshold = 60;
const closingThreshold = 60;
const defaultDurationAnimation = 200;

let allowedEvents = true;

/**
 * Reference to the header element.
 * @type {Object}
 */
let header = {};

/**
 * Reference to the side navigation element.
 * @type {Object}
 */
let sideNav = {};

/**
 * Reference to the main Nav element.
 * @type {Object}
 */
let mainNav = {};

/**
 * Reference to the search area element.
 * @type {Object}
 */
let searchArea = {};

/**
 * Height of the search area element.
 * @type {Number}
 */
let searchAreaHeight = 0;

/**
 * Reference to the "open" menu button element.
 * @type {Object}
 */
let openMenuButton = {};

/**
 * Reference to the "close" menu button element.
 * @type {Object}
 */
let closeMenuButton = {};

/**
 * Reference to the "search" button element.
 * @type {Object}
 */
let searchButton = {};

/**
 * Reference to the "search" input element.
 * @type {Object}
 */
let searchInput = {};

/**
 * Last saved top position of the window.
 * @type {Number}
 */
let scrollTop = 0;

/**
 * Indicator for whether or not the side navigation is opened.
 * @type {Boolean}
 */
let sideNavOpened = false;

/**
 * Indicator for whether or not the search field is opened.
 * @type {Boolean}
 */
let searchOpened = false;

let isSideMenuOpened = false;

function saveReferences() {
  // Get reference to the header element
  header = getHeader();

  // Side Wrapper of navigation element
  sideNav = $(`#${sideNavId}`);

  // Navigation element
  mainNav = $(`.${navMainClass}`);

  // Search area element
  searchArea = $(`#${searchAreaId}`);

  // "open" menu button element
  openMenuButton = $(`#${openMenuButtonId}`);

  // "close" menu button element
  closeMenuButton = $(`#${closeMenuButtonId}`);

  // "search" button element
  searchButton = $(`#${searchButtonId}`);

  // "search" input element
  searchInput = $(`#${searchInputId}`);
}

function saveInitialHeight() {
  if (header.length) {
    setInitialHeight(header.height());
  }

  if (searchArea.length) {
    searchAreaHeight = searchArea.outerHeight();
  }
}

function isSiteNavOpen() {
  return sideNavOpened;
}

function getSitePosition() {
  const headerHeight = header.height();

  return (
    header.length
    && (header.hasClass(overlayClass) || header.hasClass(stickyClass))
  ) ? headerHeight : 0;
}

function setSitePosition(aoOptions) {
  if (!header.length) {
    return;
  }

  const options = {
    noSiteTransition: false,
    searchAreaDelta: 0,
  };
  Object.assign(options, aoOptions);

  let position = getSitePosition();
  if (options.searchAreaDelta !== 0) {
    position += options.searchAreaDelta;
  }

  const site = $(`#${siteId}`);

  if (site.length) {
    if (options.noSiteTransition) {
      site.addClass(siteNoTransitionClass);
    }

    site.css('padding-top', position);

    if (options.noSiteTransition) {
      site.removeClass(siteNoTransitionClass);
    }
  }

  if (sideNav.length) {
    sideNav.css('padding-top', position);
  }
}

function addOverlay() {
  initialAddOverlay();

  setSitePosition({
    noSiteTransition: true,
  });
}

function showBackgroundOverlay(toggleIn = false) {
  $(popinOverlayId).toggleClass(popinOverlayHideClass, toggleIn);
}

function hideBackgroundOverlay() {
  $(popinOverlayId).addClass(popinOverlayHideClass);
}

function displaySearchButton(abHandleButton) {
  const $searchButtonContainer = searchButton.parent(`.${navItemClass}`);

  if (abHandleButton && ($searchButtonContainer.css('display') === 'none')) {
    // Show the search button
    if ($searchButtonContainer.hasClass(noDisplayClass)) {
      $searchButtonContainer
        .hide()
        .removeClass(noDisplayClass);
    }
    $searchButtonContainer
      .fadeIn()
      .attr('aria-hidden', false);
  }
}

function hideSearchArea() {
  // Update site position
  setSitePosition({
    noSiteTransition: false,
    searchAreaDelta: -1 * searchAreaHeight,
  });

  // Hide the search area
  searchButton.attr(dataSearchAreaAttr, false);
  searchArea
    .slideUp({
      duration: defaultDurationAnimation,
    })
    .attr('aria-hidden', true);

  if (!isSideMenuOpened) {
    hideBackgroundOverlay();
  }
}

function displaySearchArea(isAnimated) {
  // Update site position
  setSitePosition({
    noSiteTransition: !isAnimated,
    searchAreaDelta: searchAreaHeight,
  });

  // Show the search area
  searchArea
    .slideDown({
      duration: defaultDurationAnimation,
    })
    .attr('aria-hidden', false);

  if (!isSideMenuOpened) {
    showBackgroundOverlay();
  }
}

function addSticky() {
  if (header.hasClass(stickyClass)) {
    return;
  }

  header.addClass(stickyClass);

  const searchAreaDisplayed = (searchArea.css('display') !== 'none');
  const dataAttr = searchButton.attr(dataSearchAreaAttr);

  displaySearchButton(true);
  if ((dataAttr === 'true') && !searchAreaDisplayed) {
    displaySearchArea(true);
  } else if (searchAreaDisplayed) {
    hideSearchArea();
  }
}

function removeSticky() {
  if (!header.hasClass(stickyClass)) {
    return;
  }

  header.removeClass(stickyClass);
}

function handleScroll() {
  $(window).scroll(() => {
    if (sideNavOpened) {
      // No scroll handling when the side navigation is opened
      return;
    }

    const newScrollTop = $(document).scrollTop();

    if (newScrollTop < scrollTop) {
      // Handle up scroll

      if (newScrollTop <= closingThreshold) {
        // Closing threshold reached => back to normal display

        removeSticky();
      }
    } else if (newScrollTop > scrollTop) {
      // Handle down scroll

      if (newScrollTop > openingThreshold) {
        // Opening threshold reached => go sticky

        addSticky();
      }
    }

    // Save new top position
    scrollTop = newScrollTop;
  });
}

// header icons management - start
function getOtherButtons() {
  return $('.o-header__area .m-nav--quick-links .m-nav__item .m-nav__link')
    .not(openMenuButton)
    .not(closeMenuButton);
}

function showOtherButtons() {
  getOtherButtons().each((index, btn) => {
    const $container = $(btn).parent(`.${navItemClass}`);
    $container.animate({
      opacity: 1,
      duration: defaultDurationAnimation,
    }, 'fast', () => {
      $container
      .attr({
        'aria-hidden': false,
        visibility: '',
      });
    });
  });
}

function hideOtherButtons() {
  getOtherButtons().each((index, btn) => {
    const $container = $(btn).parent(`.${navItemClass}`);
    $container.animate({
      opacity: 1,
      duration: defaultDurationAnimation,
    }, 'fast', () => {
      $container
      .attr({
        'aria-hidden': false,
        visibility: '',
      });
    });
  });
}

function toggleBurger($target, $switch) {
  $target.parent(`.${navItemClass}`)
    .addClass(noDisplayClass)
    .attr('aria-hidden', true);

  $switch.parent(`.${navItemClass}`)
    .removeClass(noDisplayClass)
    .attr('aria-hidden', false);
}

function toggleSideNav(isIn) {
  sideNav
    .toggleClass(displaySideNavClass)
    .attr('aria-hidden', !isIn);

  // Set that the side navigation is opened
  sideNavOpened = isIn;
}
// header icons management - end

function setupEvents() {
  // Boolean allowedEvents prevent duplicated handlers
  if (allowedEvents) {
    events.registerCallback({
      target: $(document),
      events: panelRenderEvent,
      handler: (e, $el, isTopLvl) => {
        if (isTargetChildOf($el.get(0), mainNav.get(0))) {
          mainNav.prevAll().toggle(isTopLvl);
          mainNav.nextAll().toggle(isTopLvl);

          sideNav.scrollTop(0);
        }
      }
    });

    events.registerCallback({
      target: sideNav,
      events: 'click',
      handler: (e) => {
        if (!isTargetChildOf(e.currentTarget, mainNav.get(0))) {
          closeMenuButton.trigger('click');
        }
      }
    });

    events.registerCallback({
      target: openMenuButton,
      events: 'click',
      handler: function onOpenMenuButtonClick() {
        isSideMenuOpened = true;
        // Lock scroll for the body
        Page.scrollLocked();
        toggleBurger($(this), closeMenuButton);
        hideOtherButtons();

        const searchAreaDisplayed = (searchArea.css('display') === 'none');
        if (searchAreaDisplayed) {
          displaySearchArea(true);
          searchInput.focus();
        }

        const popinAddToBag = $('#addToBag');
        if (popinAddToBag.length >= 1) {
          popinAddToBag.find('.js-popin-close').first().click();
        }

        if (sideNav.length) {
          toggleSideNav(true);

          // Set focus on the first menu item
          const $firstMenuItem = $(`.${navMainClass}`).find(':focusable').filter(':first');
          if ($firstMenuItem.length) {
            $firstMenuItem.focus();
          }
        } else {
          // Set focus on the close button
          closeMenuButton.focus();
        }
      },
    });

    events.registerCallback({
      target: closeMenuButton,
      events: 'click',
      handler: function onCloseMenuButtonClick() {
        isSideMenuOpened = false;
        // Unlock scroll for the body
        Page.scrollUnlocked();
        toggleBurger($(this), openMenuButton);
        resetContainer($(`.${navMainClass}`));
        showOtherButtons();
        toggleSideNav(false);

        const searchAreaDisplayed = (searchArea.css('display') !== 'none');
        if (searchAreaDisplayed) {
          hideSearchArea();
        }

        if (searchOpened && searchArea.css('display') === 'none') {
          searchButton.trigger('click');
        } else {
          searchOpened = false;
        }

        // Set focus on the open button
        openMenuButton.focus();
      },
    });

    events.registerCallback({
      target: searchButton,
      events: 'click',
      handler: function onSearchButtonClick() {
        if (searchArea.css('display') === 'none') {
          searchOpened = true;
          displaySearchArea(true);
          // Set focus on the search input
          searchInput.focus();
        } else {
          searchOpened = false;
          hideSearchArea();
        }
      },
    });
  }
}

function handleWindowResize() {
  registerWindowResizeCallback(() => {
    // Reset initial height
    saveInitialHeight();
    // Reset site position
    setSitePosition({
      noSiteTransition: false,
    });
  });
}

function init() {
  initialInit();
  // Save references to DOM elements
  saveReferences();
  // Save initial height
  saveInitialHeight();
  // Set overlay state
  addOverlay();
  // Handle the show/hide on scroll
  handleScroll();
  // Handle buttons
  setupEvents();
  // Handle window resize
  handleWindowResize();

  if (!isAlgoliaOn()) {
    // Call init of the legacy search
    search.init();
  }

  // Call init of the cart
  cart.init();
  // Call init of the cart items
  cartItemsInit();
  allowedEvents = false;
}

// Named exports - Constants
export {
  siteId,
  headerId,
  sideNavId,
  searchAreaId,
  openMenuButtonId,
  closeMenuButtonId,
  searchButtonId,
  navMainClass,
  overlayClass,
  stickyClass,
};

// Named exports - Functions
export {
  init,
  setSitePosition,
  addSticky,
  removeSticky,
  showBackgroundOverlay,
  hideBackgroundOverlay,
  toggleBurger,
  toggleSideNav,
  isSiteNavOpen
};

// Named exports - Modules
export {
  search,
};



// WEBPACK FOOTER //
// ./js/mobile/organism/header.js